import * as React from "react";
import { TableCellRenderer } from "react-table";

import { CustomTableColumn } from "src/library/components/Tables/Table";
import * as globalTableColumns from "src/core/shared/components/TableGlobalColumns";
import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import { Link } from "src/library/components/Link";
import { Text } from "src/library/components/Text";

export type UserTableType = "admin" | "customer";

export interface UserTableProps {
  ActionButton: TableCellRenderer;
  type?: UserTableType;
  terminology?: ITerminology;
  disableFilters?: boolean;
}

export const usersTableColumns = (params: UserTableProps): CustomTableColumn[] => {
  const {
    ActionButton, terminology, type = "admin"
  } = params;

  const columns = [
    globalTableColumns.id(),
    globalTableColumns.standardText({
      Header: "Email",
      accessor: "email",
      width: 250,
      textTransform: "none",
      filterable: !params.disableFilters
    }),
    globalTableColumns.standardText({
      Header: "Role",
      accessor: "role.name",
      width: 200,
      filterable: true,
      sortable: false
    }),
    globalTableColumns.standardText({
      Header: "First Name",
      id: "firstName",
      width: 200,
      accessor: "firstName",
      filterable: !params.disableFilters
    }),
    globalTableColumns.standardText({
      Header: "Last Name",
      id: "lastName",
      width: 200,
      accessor: "lastName",
      filterable: !params.disableFilters
    }),
    globalTableColumns.status(),
    globalTableColumns.date({
      header: "Last Logged In",
      id: "lastLoggedIn",
      width: 100,
      accessor: "lastLoggedIn",
      template: "datetime",
      sortable: false
    })
  ];

  // include customer and drop assocation if customer users
  if (type === "customer") {
    columns.push(...[
      globalTableColumns.standardText({
        Header: `Default ${terminology?.drop.singular.text || "Drop"}`,
        id: "branch",
        sortable: false,
        accessor: "branch.branchNumber"
      }),
      globalTableColumns.standardText({
        Header: terminology?.customer.singular.text || "Customer",
        id: "customer",
        accessor: "customer.accountNumber",
        sortable: false,
        Cell: row => (
          <Link
            color="primary"
            type="underlined"
            to={`/admin/customers/${row.original.customerId}/users`}
          >
            {row.value}
          </Link>
        )
      })
    ]);
  }

  // attach buttons to the end
  columns.push(globalTableColumns.actions({ cell: ActionButton }));

  return columns;
};
